import type { PayPalScriptOptions } from '@paypal/paypal-js';
import { Preferences } from '@interfaces/models/preferences';

export class PayPalOSMService {
  static isEligible({ currency, country }: Partial<Preferences>): boolean {
    const posibilities = {
      GB: ['GBP'],
      FR: ['EUR'],
      DE: ['EUR'],
      US: ['USD'],
      AU: ['AUD'],
      IT: ['EUR'],
      ES: ['EUR'],
    };
    return (posibilities[country] || []).includes(currency);
  }

  static getConfigs(): PayPalScriptOptions {
    return {
      clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID_PDP || '',
      components: 'messages',
      dataNamespace: 'paypal_sdk',
    };
  }
}

export default {};
